import Backdrop from 'components/Backdrop';
import React, { useState } from 'react';
import Header from '../Header';
import Sidebar from '../Sidebar';

interface DashboardLayoutProps {
  children: any;
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const [show, setShow] = useState<boolean>(
    window.innerWidth > 992 ? true : false,
  );
  const sidebarHandler = () => {
    setShow(!show);
    if (window.innerWidth < 992) {
      document.body.classList.toggle('overflow-hidden');
    }
  };

  return (
    <div className="dashboard-layout d-flex">
      <Sidebar
        className="d-lg-block"
        active={show}
        sidebarHandler={sidebarHandler}
      />
      <div className={`wrapper p-lg-3 ${show ? 'show' : 'hide'}`}>
        <Header sidebarHandler={sidebarHandler} />
        <main className="mt-3">{children}</main>
        <Backdrop show={show} sidebarHandler={sidebarHandler} />
      </div>
    </div>
  );
};

export default DashboardLayout;
